<template>
    <div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/random/discount/edit')" type="primary" icon="el-icon-plus" size="small"
                 @click="$refs.add.show()">创建活动</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="id" label="活动ID"></el-table-column>
                <el-table-column prop="name" label="活动名称" show-overflow-tooltip></el-table-column>
                <el-table-column  label="活动限制类型" min-width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.showTypeTagView">{{scope.row.showTypeTagView}}</span>
						<span v-else class="color-success">限制演出</span>
					</template>
				</el-table-column>
                <el-table-column prop="serviceFeeRateView" label="票提上限百分比" min-width="120">
                    <template slot-scope="scope">
                        {{scope.row.serviceFeeRateView}}%
                    </template>
                </el-table-column>
                <el-table-column prop="statusView" label="状态"></el-table-column>
				<el-table-column label="活动起止时间" min-width="200">
					<template slot-scope="scope">
					    <p>起：{{scope.row.startTime}}</p>
						<p>止：{{scope.row.endTime}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="orderNum" label="立减活动订单数" min-width="120"></el-table-column>
				<el-table-column prop="userNum" label="立减活动用户数" min-width="120"></el-table-column>
				<el-table-column prop="newUserNum" label="立减活动新用户数" min-width="120"></el-table-column>
				<el-table-column prop="discountCount" label="立减优惠金额" min-width="120"></el-table-column>                	
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/random/discount/edit')"
                            type="text"
                            size="small"
                            @click="edit(scope.row)"
                            >管理</el-button
                        >
						<el-button
						    v-if="$utils.have('/random/discount/statistics')"
						    type="text"
						    size="small"
						    @click="view(scope.row.id,scope.row.startTime,scope.row.endTime)"
						    >数据</el-button
						>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
       <add ref="add" @onUpdate="getDataList()"></add>
    </div>
</template>
<script>
import Add from './components/add.vue'
const defaultParams = {
    pageNo: 1,
    
}
export default {
    components:{
       Add
    },
    data(){
        return{
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                
            },
            listLoading: true,
            downLoading:false,
        }
    },
   
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/random/discount/pageList",
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
       //编辑事件
       edit(data){
           this.$refs.add.show(data);
       },
        //详情
        view(id,startTime,endTime){
            this.$router.push({
                path: `/promotion/instant/details/${id}/${startTime}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                    startTime: startTime,
                    endTime: endTime,
                },
            });
        },
		
       
    }
}
</script>
<style lang="scss" scoped>

</style>